function Top() {
  return (
    <a class="btn btn-dark" href="#top" role="button">
      Back to Top
    </a>
  );
}

export default Top;
